import { FileMarkerOutlineIcon } from './FileMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 96A7C92B-3EDA-40C8-B21D-45355968345C
 * name file-marker-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-marker-outline.svg
 * tags
 * - Files / Folders 
 * - Navigation 
 */
export const FileLocationOutlineIcon = FileMarkerOutlineIcon;
export default FileLocationOutlineIcon